import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
import { colors } from '@global/constants'

interface DataPoint {
  x: string
  y: number
}

interface LineData {
  id: string
  data: DataPoint[]
}

interface LineGraphProps {
  data?: LineData[]
}

export const LineGraph = ({ data = [] }: LineGraphProps) => {
  const graphColors = [colors.blue.main, colors.green.main, colors.red.main, colors.purple.main]

  const first = data[0]

  if (!first) {
    return null
  }

  // Transform data for Recharts format
  const transformedData =
    first?.data.map(point => ({
      x: point.x,
      [first.id]: point.y,
    })) || []

  return (
    <div className="w-full h-[480px]">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={transformedData}
          margin={{
            top: 50,
            right: 60,
            bottom: 50,
            left: 60,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="x" />
          <YAxis />
          <Tooltip />
          {data.map((series, index) => (
            <Line
              key={series.id}
              type="monotone"
              dataKey={series.id}
              stroke={graphColors[index % graphColors.length]}
              dot={{ r: 4 }}
              activeDot={{ r: 8 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
